import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { setLocale } from '@app/i18n';
import { useMe } from '@app/api';
import { ParticipantNavbar } from './components/ParticipantNavbar';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';

export const Dashboard = () => {
  const { data: me } = useMe();
  useEffect(() => {
    if (me?.locale) {
      setLocale(me.locale);
    }
  }, [me?.locale]);

  return (
    <AnalyticsCategoryProvider category={Categories.PARTICIPANT}>
      <ParticipantNavbar>
        <Outlet />
      </ParticipantNavbar>
    </AnalyticsCategoryProvider>
  );
};
